// before 20-5-2026


// last code with 5 quations and new design
// import React, { useEffect, useState } from 'react';
// import { Col, Container, Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import Card from '@mui/material/Card';
// import CardMedia from '@mui/material/CardMedia';
// import Typography from '@mui/material/Typography';
// import CardActionArea from '@mui/material/CardActionArea';
// import zapier from '../../images/zapier.jpeg';
// import make from '../../images/make.jpg';
// import integrately from '../../images/integrately.webp';
// import { GetAll_stage_Data } from '../../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../../Redux/Actions/Campaign_Actions';
// import { useDispatch, useSelector } from 'react-redux';
// import { GetallProjectsdata } from '../../Redux/Actions/Projects_Action';
// import { Get_All_Sales_Action } from '../../Redux/Actions/SalesAction';
// import { useNavigate } from 'react-router-dom';
// import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
// import CopyToClipboard from 'react-copy-to-clipboard';
// import { Notify } from '../../Utility/Notify';
// import {
//   Alert,
//   Autocomplete,
//   Checkbox,
//   FormControl,
//   FormControlLabel,
//   ListItemText,
//   Snackbar,
//   TextField,
//   Box,
//   Paper,
//   Divider,
//   IconButton,
//   Tooltip,
//   Chip,
//   Button,
//   Grid,
//   Avatar,
//   useMediaQuery,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { db_url } from '../../Api/BaseUrl';
// import { LeedintegrationKeys } from './LeedintegrationKeys';
// import AddIcon from '@mui/icons-material/Add';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
// import LinkIcon from '@mui/icons-material/Link';

// const allIntegration = [
//   {
//     id: 1,
//     name: 'Zapier',
//     description: 'Connect with thousands of apps',
//     link: 'https://zapier.com/l/home?utm_source=google&utm_medium=cpc&utm_campaign=gaw-gbl-nua-evr-search_brand_alldev_prospecting_trademark_core_d1-ads&utm_term=zapier&utm_content=9198874&utm_ads_campaign_id=17565686763&utm_ads_adset_id=139732742522&utm_ads_ad_id=732605974017&gad_source=1&gclid=CjwKCAiAiOa9BhBqEiwABCdG8zzu9x5JT_muF1bmM-156DGQREYJF96qKf_4AaYSHmXnamgR4t5sHBoCNgYQAvD_BwE',
//     img: zapier,
//     color: '#FF4F00',
//   },
//   {
//     id: 2,
//     name: 'Make',
//     description: 'Visual automation platform',
//     link: 'https://www.make.com/en?pc=xyz123&msclkid=6b927d7f83cf17eadb501ac630fa28ef',
//     img: make,
//     color: '#6E48AA',
//   },
//   {
//     id: 3,
//     name: 'Integrately',
//     description: '1-click integrations',
//     link: 'https://app.integrately.com/',
//     img: integrately,
//     color: '#00A67E',
//   },
// ];

// export const MoreIntegration = () => {
//   const [userlogin, setuserlogin] = useState('');
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const dispatch = useDispatch();

//   // states for autocomplete
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [selectedSales, setSelectedSales] = useState(null);
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [selectedChannal, setSelectedChannal] = useState(null);
//   const [selectedCommunicationway, setSelectedCommunicationway] = useState(null);
//   const [selectedCampaign, setSelectedCampaign] = useState(null);

//   const [projectInputValue, setProjectInputValue] = useState('');
//   const [salesInputValue, setSalesInputValue] = useState('');
//   const [stageInputValue, setStageInputValue] = useState('');
//   const [channalInputValue, setChannalInputValue] = useState('');
//   const [communicationwayInputValue, setCommunicationwayInputValue] = useState('');
//   const [campaignInputValue, setCampaignInputValue] = useState('');

//   const [project, setproject] = useState('');
//   const [salesdata, setsalesdata] = useState('');
//   const [stage, setstage] = useState('');
//   const [Channal, setchannal] = useState('');
//   const [Communicationway, setcommunicationwat] = useState('');
//   const [campaignid, setcampaignid] = useState('');
  
//   // Existing optional fields
//   const [includeWhatsapp, setIncludeWhatsapp] = useState(false);
//   const [includePhone2, setIncludePhone2] = useState(false);
//   const [includeJobDesc, setIncludeJobDesc] = useState(false);
  
//   // Questions states
//   const [includeQuestion1, setIncludeQuestion1] = useState(false);
//   const [includeQuestion2, setIncludeQuestion2] = useState(false);
//   const [includeQuestion3, setIncludeQuestion3] = useState(false);
//   const [includeQuestion4, setIncludeQuestion4] = useState(false);
//   const [includeQuestion5, setIncludeQuestion5] = useState(false);
  
//   // Question texts only (answers will come from form later)
//   const [question1_text, setQuestion1_text] = useState('');
//   const [question2_text, setQuestion2_text] = useState('');
//   const [question3_text, setQuestion3_text] = useState('');
//   const [question4_text, setQuestion4_text] = useState('');
//   const [question5_text, setQuestion5_text] = useState('');
  
//   // Campaign Redirect Link state
//   const [campaignRedirectLink, setCampaignRedirectLink] = useState('');

//   // Autocomplete handlers
//   const handleProjectChange = (event, newValue) => {
//     setSelectedProject(newValue);
//     setproject(newValue ? newValue._id : '');
//   };

//   const handleSalesChange = (event, newValue) => {
//     setSelectedSales(newValue);
//     setsalesdata(newValue ? newValue._id : '');
//   };

//   const handleStageChange = (event, newValue) => {
//     setSelectedStage(newValue);
//     setstage(newValue ? newValue._id : '');
//   };

//   const handleChannalChange = (event, newValue) => {
//     setSelectedChannal(newValue);
//     setchannal(newValue ? newValue._id : '');
//   };

//   const handleCommunicationwayChange = (event, newValue) => {
//     setSelectedCommunicationway(newValue);
//     setcommunicationwat(newValue ? newValue._id : '');
//   };

//   const handleCampaignChange = (event, newValue) => {
//     setSelectedCampaign(newValue);
//     setcampaignid(newValue ? newValue._id : '');
//   };

//   useEffect(() => {
//     const getstages = async () => {
//       await dispatch(GetAll_stage_Data());
//       await dispatch(GetAllchannalData());
//       await dispatch(GetCommunicationwayData());
//       await dispatch(GetAllCampainData());
//     };
//     getstages();
//   }, [dispatch]);

//   const resgetallstages = useSelector((state) => state.Allstages.stage);
//   const resgetallchannal = useSelector((state) => state.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(
//     (state) => state.AllCommunicationway.communicationway,
//   );
//   const resgetcampaindata = useSelector((state) => state.AllCampaign.campaign);

//   let res_getallstages_array = Array.isArray(resgetallstages?.data) ? resgetallstages.data : [];
//   let res_getallchannal_array = Array.isArray(resgetallchannal?.data) ? resgetallchannal.data : [];
//   let res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data)
//     ? resgetallcommunicationway.data
//     : [];
//   let res_get_campaign_data_array = Array.isArray(resgetcampaindata?.data)
//     ? resgetcampaindata.data
//     : [];

//   const ressales = useSelector((state) => state.AllSales.sales);

//   let salesData = (Array.isArray(ressales?.data) ? ressales.data : [])
//     .filter(
//       (sale) =>
//         ![
//           'Default',
//           'Default M',
//           'Default T',
//           'Default S',
//           'Deveolper',
//           'Developer',
//           'Dev',
//         ].includes(sale.name),
//     )
//     .sort((a, b) => {
//       if (a.name === 'No Sales') return -1;
//       if (b.name === 'No Sales') return 1;
//       return 0;
//     });

//   useEffect(() => {
//     const getprojects = async () => {
//       await dispatch(GetallProjectsdata());
//       await dispatch(Get_All_Sales_Action());
//     };
//     getprojects();
//   }, []);

//   const resProjects = useSelector((state) => state.AllProjects.Projects);

//   let Allprojects = [];
//   if (resProjects && resProjects.data) {
//     Allprojects = resProjects.data;
//   } else {
//     Allprojects = [];
//   }

//   let user = '';
//   if (localStorage.getItem('user') != null) {
//     user = JSON.parse(localStorage.getItem('user'));
//   }

//   const [selectedValuesintegration, setselectedValuesintegration] = useState({
//     addedby: user.data?._id || '',
//   });

//   const [urlcreated, seturlcreated] = useState('');
//   const [generate, setgenerate] = useState(true);
//   const [copied, setCopied] = useState(false);

//   // ✅ Updated useEffect - ONLY question texts, NO answers
//   useEffect(() => {
//     const params = {
//       addedby: user.data?._id || '',
//       stage,
//       Channal,
//       project,
//       salesdata,
//       Communicationway,
//       campaignid,
//       includePhone2: includePhone2 ? 'true' : 'false',
//       includeWhatsapp: includeWhatsapp ? 'true' : 'false',
//       includeJobDesc: includeJobDesc ? 'true' : 'false',
//       // Questions flags
//       includeQuestion1: includeQuestion1 ? 'true' : 'false',
//       includeQuestion2: includeQuestion2 ? 'true' : 'false',
//       includeQuestion3: includeQuestion3 ? 'true' : 'false',
//       includeQuestion4: includeQuestion4 ? 'true' : 'false',
//       includeQuestion5: includeQuestion5 ? 'true' : 'false',
//       // ✅ Question texts only (answers will be in body)
//       ...(includeQuestion1 && question1_text && { question1_text }),
//       ...(includeQuestion2 && question2_text && { question2_text }),
//       ...(includeQuestion3 && question3_text && { question3_text }),
//       ...(includeQuestion4 && question4_text && { question4_text }),
//       ...(includeQuestion5 && question5_text && { question5_text }),
//       // Campaign redirect link
//       ...(campaignRedirectLink && { campaignRedirectLink }),
//     };

//     // Remove undefined values
//     Object.keys(params).forEach(key => 
//       params[key] === undefined && delete params[key]
//     );

//     setselectedValuesintegration(params);
//   }, [
//     stage,
//     Channal,
//     project,
//     salesdata,
//     Communicationway,
//     campaignid,
//     includePhone2,
//     includeWhatsapp,
//     includeJobDesc,
//     includeQuestion1,
//     includeQuestion2,
//     includeQuestion3,
//     includeQuestion4,
//     includeQuestion5,
//     question1_text,
//     question2_text,
//     question3_text,
//     question4_text,
//     question5_text,
//     campaignRedirectLink,
//     user.data?._id,
//   ]);

//   const generateUrl = () => {
//     // Validate required fields
//     if (project === '') {
//       Notify('error', 'Project is required', 'error');
//       return;
//     } else if (salesdata === '') {
//       Notify('error', 'Sales is required', 'error');
//       return;
//     } else if (Channal === '') {
//       Notify('error', 'Channel is required', 'error');
//       return;
//     } else if (Communicationway === '') {
//       Notify('error', 'Communication way is required', 'error');
//       return;
//     } else if (stage === '') {
//       Notify('error', 'Stage is required', 'error');
//       return;
//     } else if (campaignid === '') {
//       Notify('error', 'Campaign is required', 'error');
//       return;
//     } else if (!user.data?._id) {
//       Notify('error', 'User is required', 'error');
//       return;
//     }

//     // ✅ Validate question texts if included
//     if (includeQuestion1 && !question1_text) {
//       Notify('error', 'Question 1 text is required', 'error');
//       return;
//     }
//     if (includeQuestion2 && !question2_text) {
//       Notify('error', 'Question 2 text is required', 'error');
//       return;
//     }
//     if (includeQuestion3 && !question3_text) {
//       Notify('error', 'Question 3 text is required', 'error');
//       return;
//     }
//     if (includeQuestion4 && !question4_text) {
//       Notify('error', 'Question 4 text is required', 'error');
//       return;
//     }
//     if (includeQuestion5 && !question5_text) {
//       Notify('error', 'Question 5 text is required', 'error');
//       return;
//     }

//     const baseUrl = '';
//     const queryParams = new URLSearchParams(selectedValuesintegration).toString();

//     const newUrl = `${baseUrl}?${queryParams}`;
//     seturlcreated(`${db_url}api/v1/users/create-with-params` + newUrl);
//     setgenerate(false);
//     setCopied(false);
//   };

//   const handleCopy = () => {
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   // Dashboard route based on user role
//   const dashboardRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/dashboard'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/dashboard'
//         : '/';

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         backgroundColor: mode === 'dark' ? '#0a1929' : '#f8fafc',
//         py: 4,
//       }}
//       className="startpage"
//     >
//       <Container>
//         <Row>
//           <Col sm={2}></Col>
//           <Col sm={10}>
//             {/* Breadcrumb */}
//             <Paper
//               elevation={0}
//               sx={{
//                 p: 2,
//                 mb: 3,
//                 backgroundColor: 'transparent',
//                 display: 'flex',
//                 alignItems: 'center',
//                 flexWrap: 'wrap',
//                 gap: 1,
//               }}
//             >
//               <Link to={dashboardRoute} style={{ textDecoration: 'none' }}>
//                 <Typography
//                   component="span"
//                   sx={{
//                     color: '#102dff',
//                     fontWeight: '600',
//                     '&:hover': { textDecoration: 'underline' },
//                   }}
//                 >
//                   Dashboard
//                 </Typography>
//               </Link>
//               <KeyboardDoubleArrowRightIcon sx={{ color: '#666', fontSize: 18 }} />
//               <Typography component="span" sx={{ color: '#666' }}>
//                 Integration
//               </Typography>
//               <KeyboardDoubleArrowRightIcon sx={{ color: '#666', fontSize: 18 }} />
//               <Typography component="span" sx={{ color: '#666' }}>
//                 More Integration
//               </Typography>
//             </Paper>

//             {/* Header */}
//             <Box sx={{ mb: 4 }}>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   fontWeight: '700',
//                   color: mode === 'dark' ? '#fff' : '#102dff',
//                   mb: 1,
//                 }}
//               >
//                 Integration Hub
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   color: mode === 'dark' ? '#aaa' : '#666',
//                   fontSize: '1.1rem',
//                 }}
//               >
//                 Connect your leads with popular automation platforms
//               </Typography>
//             </Box>

//             {/* Integration Cards */}
//             <Grid container spacing={3} sx={{ mb: 4 }}>
//               {allIntegration.map((item) => (
//                 <Grid item xs={12} sm={6} md={4} key={item.id}>
//                   <Card
//                     sx={{
//                       height: '100%',
//                       transition: 'transform 0.3s, box-shadow 0.3s',
//                       '&:hover': {
//                         transform: 'translateY(-8px)',
//                         boxShadow: `0 12px 24px ${mode === 'dark' ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0.15)'}`,
//                         borderColor: item.color,
//                       },
//                       border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//                       borderRadius: 3,
//                       overflow: 'hidden',
//                     }}
//                   >
//                     <a
//                       href={item.link}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       style={{ textDecoration: 'none' }}
//                     >
//                       <CardActionArea>
//                         <Box sx={{ position: 'relative' }}>
//                           <CardMedia
//                             component="img"
//                             height="160"
//                             image={item.img}
//                             alt={item.name}
//                             sx={{ objectFit: 'cover' }}
//                           />
//                           <Box
//                             sx={{
//                               position: 'absolute',
//                               top: 0,
//                               left: 0,
//                               right: 0,
//                               bottom: 0,
//                               background: `linear-gradient(135deg, ${item.color}40 0%, transparent 100%)`,
//                             }}
//                           />
//                         </Box>
//                         <Box sx={{ p: 2, textAlign: 'center' }}>
//                           <Typography
//                             gutterBottom
//                             variant="h6"
//                             component="div"
//                             sx={{
//                               fontWeight: '700',
//                               color: mode === 'dark' ? '#fff' : item.color,
//                             }}
//                           >
//                             {item.name}
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               color: mode === 'dark' ? '#aaa' : '#666',
//                             }}
//                           >
//                             {item.description}
//                           </Typography>
//                           <Chip
//                             label="Connect →"
//                             size="small"
//                             sx={{
//                               mt: 2,
//                               backgroundColor: item.color,
//                               color: 'white',
//                               fontWeight: '500',
//                               '&:hover': {
//                                 backgroundColor: item.color,
//                                 opacity: 0.9,
//                               },
//                             }}
//                           />
//                         </Box>
//                       </CardActionArea>
//                     </a>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>

//             {/* Configuration Section */}
//             <Paper
//               elevation={3}
//               sx={{
//                 p: { xs: 2, sm: 3, md: 4 },
//                 borderRadius: 4,
//                 backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//                 border: `1px solid ${mode === 'dark' ? '#333' : '#e0e0e0'}`,
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
//                 <Avatar sx={{ bgcolor: '#102dff', width: 48, height: 48 }}>
//                   <CreateNewFolderIcon />
//                 </Avatar>
//                 <Box>
//                   <Typography variant="h5" sx={{ fontWeight: '700', color: '#102dff' }}>
//                     Integration Configuration
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: mode === 'dark' ? '#aaa' : '#666' }}>
//                     Configure your integration settings below
//                   </Typography>
//                 </Box>
//               </Box>

//               <Divider sx={{ mb: 4, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />

//               <Grid container spacing={3}>
//                 {/* Required Fields Section */}
//                 <Grid item xs={12}>
//                   <Typography
//                     variant="subtitle1"
//                     sx={{
//                       fontWeight: '600',
//                       color: '#102dff',
//                       mb: 2,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         backgroundColor: '#102dff',
//                       }}
//                     />
//                     Required Fields
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={Allprojects || []}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={selectedProject}
//                     onChange={handleProjectChange}
//                     inputValue={projectInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setProjectInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Project *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={salesData || []}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={selectedSales}
//                     onChange={handleSalesChange}
//                     inputValue={salesInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setSalesInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Sales *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                     renderOption={(props, option) => (
//                       <li {...props} key={option._id}>
//                         <Box>
//                           <Typography variant="body2">{option.name}</Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {option?.userlog?.role || 'No role'}
//                           </Typography>
//                         </Box>
//                       </li>
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={res_getallstages_array || []}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={selectedStage}
//                     onChange={handleStageChange}
//                     inputValue={stageInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setStageInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Stage *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={res_getallchannal_array || []}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={selectedChannal}
//                     onChange={handleChannalChange}
//                     inputValue={channalInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setChannalInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Channel *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={res_getallcommunicationway_array || []}
//                     getOptionLabel={(option) => option.name || ''}
//                     value={selectedCommunicationway}
//                     onChange={handleCommunicationwayChange}
//                     inputValue={communicationwayInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setCommunicationwayInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Communication Way *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Autocomplete
//                     options={res_get_campaign_data_array || []}
//                     getOptionLabel={(option) => option.CampainName || ''}
//                     value={selectedCampaign}
//                     onChange={handleCampaignChange}
//                     inputValue={campaignInputValue}
//                     onInputChange={(event, newInputValue) => {
//                       setCampaignInputValue(newInputValue);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label="Campaign *"
//                         variant="outlined"
//                         required
//                         size="small"
//                       />
//                     )}
//                   />
//                 </Grid>

//                 {/* Optional Fields Section - Basic */}
//                 <Grid item xs={12}>
//                   <Divider sx={{ my: 2, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />
//                   <Typography
//                     variant="subtitle1"
//                     sx={{
//                       fontWeight: '600',
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       mb: 2,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 8,
//                         height: 8,
//                         borderRadius: '50%',
//                         backgroundColor: mode === 'dark' ? '#aaa' : '#666',
//                       }}
//                     />
//                     Basic Optional Fields
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={includeWhatsapp}
//                           onChange={(e) => setIncludeWhatsapp(e.target.checked)}
//                           sx={{ color: '#102dff' }}
//                         />
//                       }
//                       label="Include WhatsApp Number"
//                     />
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={includePhone2}
//                           onChange={(e) => setIncludePhone2(e.target.checked)}
//                           sx={{ color: '#102dff' }}
//                         />
//                       }
//                       label="Include Secondary Phone"
//                     />
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={includeJobDesc}
//                           onChange={(e) => setIncludeJobDesc(e.target.checked)}
//                           sx={{ color: '#102dff' }}
//                         />
//                       }
//                       label="Include Job Description"
//                     />
//                   </Box>
//                 </Grid>

//                 {/* Campaign Redirect Link */}
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Campaign Redirect Link"
//                     variant="outlined"
//                     size="small"
//                     value={campaignRedirectLink}
//                     onChange={(e) => setCampaignRedirectLink(e.target.value)}
//                     placeholder="https://example.com/thank-you"
//                     InputProps={{
//                       startAdornment: (
//                         <LinkIcon sx={{ mr: 1, color: mode === 'dark' ? '#aaa' : '#666' }} />
//                       ),
//                     }}
//                     helperText="Optional: URL to redirect after lead creation"
//                   />
//                 </Grid>

//                 {/* Questions Section - Text Only (Answers will come from form) */}
//                 <Grid item xs={12}>
//                   <Divider sx={{ my: 2, backgroundColor: mode === 'dark' ? '#333' : '#e0e0e0' }} />
//                   <Typography
//                     variant="subtitle1"
//                     sx={{
//                       fontWeight: '600',
//                       color: mode === 'dark' ? '#aaa' : '#666',
//                       mb: 2,
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                     }}
//                   >
//                     <HelpOutlineIcon sx={{ fontSize: 20 }} />
//                     Custom Questions - Text Only (Answers will come from form)
//                   </Typography>
//                 </Grid>

//                 {/* Question 1 - Text Only */}
//                 <Grid item xs={12}>
//                   <Accordion 
//                     sx={{ 
//                       backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//                       boxShadow: 'none',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={includeQuestion1}
//                               onChange={(e) => setIncludeQuestion1(e.target.checked)}
//                               sx={{ color: '#102dff' }}
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           }
//                           label="Question 1"
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                         {includeQuestion1 && (
//                           <Chip 
//                             label="Included" 
//                             size="small" 
//                             sx={{ 
//                               backgroundColor: '#102dff', 
//                               color: 'white',
//                               height: 20,
//                               fontSize: '10px',
//                             }} 
//                           />
//                         )}
//                       </Box>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label="Question 1 Text"
//                             variant="outlined"
//                             size="small"
//                             value={question1_text}
//                             onChange={(e) => setQuestion1_text(e.target.value)}
//                             disabled={!includeQuestion1}
//                             placeholder="e.g., What is your budget?"
//                             required={includeQuestion1}
//                             error={includeQuestion1 && !question1_text}
//                             helperText={includeQuestion1 && !question1_text ? "Question text is required" : ""}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <Typography variant="caption" color="text.secondary">
//                             ⓘ Answer will be provided by the customer in the form
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                 </Grid>

//                 {/* Question 2 - Text Only */}
//                 <Grid item xs={12}>
//                   <Accordion 
//                     sx={{ 
//                       backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//                       boxShadow: 'none',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={includeQuestion2}
//                               onChange={(e) => setIncludeQuestion2(e.target.checked)}
//                               sx={{ color: '#102dff' }}
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           }
//                           label="Question 2"
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                         {includeQuestion2 && (
//                           <Chip 
//                             label="Included" 
//                             size="small" 
//                             sx={{ 
//                               backgroundColor: '#102dff', 
//                               color: 'white',
//                               height: 20,
//                               fontSize: '10px',
//                             }} 
//                           />
//                         )}
//                       </Box>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label="Question 2 Text"
//                             variant="outlined"
//                             size="small"
//                             value={question2_text}
//                             onChange={(e) => setQuestion2_text(e.target.value)}
//                             disabled={!includeQuestion2}
//                             placeholder="e.g., When do you plan to buy?"
//                             required={includeQuestion2}
//                             error={includeQuestion2 && !question2_text}
//                             helperText={includeQuestion2 && !question2_text ? "Question text is required" : ""}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <Typography variant="caption" color="text.secondary">
//                             ⓘ Answer will be provided by the customer in the form
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                 </Grid>

//                 {/* Question 3 - Text Only */}
//                 <Grid item xs={12}>
//                   <Accordion 
//                     sx={{ 
//                       backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//                       boxShadow: 'none',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={includeQuestion3}
//                               onChange={(e) => setIncludeQuestion3(e.target.checked)}
//                               sx={{ color: '#102dff' }}
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           }
//                           label="Question 3"
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                         {includeQuestion3 && (
//                           <Chip 
//                             label="Included" 
//                             size="small" 
//                             sx={{ 
//                               backgroundColor: '#102dff', 
//                               color: 'white',
//                               height: 20,
//                               fontSize: '10px',
//                             }} 
//                           />
//                         )}
//                       </Box>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label="Question 3 Text"
//                             variant="outlined"
//                             size="small"
//                             value={question3_text}
//                             onChange={(e) => setQuestion3_text(e.target.value)}
//                             disabled={!includeQuestion3}
//                             placeholder="e.g., What property type?"
//                             required={includeQuestion3}
//                             error={includeQuestion3 && !question3_text}
//                             helperText={includeQuestion3 && !question3_text ? "Question text is required" : ""}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <Typography variant="caption" color="text.secondary">
//                             ⓘ Answer will be provided by the customer in the form
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                 </Grid>

//                 {/* Question 4 - Text Only */}
//                 <Grid item xs={12}>
//                   <Accordion 
//                     sx={{ 
//                       backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//                       boxShadow: 'none',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={includeQuestion4}
//                               onChange={(e) => setIncludeQuestion4(e.target.checked)}
//                               sx={{ color: '#102dff' }}
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           }
//                           label="Question 4"
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                         {includeQuestion4 && (
//                           <Chip 
//                             label="Included" 
//                             size="small" 
//                             sx={{ 
//                               backgroundColor: '#102dff', 
//                               color: 'white',
//                               height: 20,
//                               fontSize: '10px',
//                             }} 
//                           />
//                         )}
//                       </Box>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label="Question 4 Text"
//                             variant="outlined"
//                             size="small"
//                             value={question4_text}
//                             onChange={(e) => setQuestion4_text(e.target.value)}
//                             disabled={!includeQuestion4}
//                             placeholder="e.g., Preferred location?"
//                             required={includeQuestion4}
//                             error={includeQuestion4 && !question4_text}
//                             helperText={includeQuestion4 && !question4_text ? "Question text is required" : ""}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <Typography variant="caption" color="text.secondary">
//                             ⓘ Answer will be provided by the customer in the form
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                 </Grid>

//                 {/* Question 5 - Text Only */}
//                 <Grid item xs={12}>
//                   <Accordion 
//                     sx={{ 
//                       backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f9f9f9',
//                       boxShadow: 'none',
//                       border: `1px solid ${mode === 'dark' ? '#444' : '#e0e0e0'}`,
//                     }}
//                   >
//                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//                         <FormControlLabel
//                           control={
//                             <Checkbox
//                               checked={includeQuestion5}
//                               onChange={(e) => setIncludeQuestion5(e.target.checked)}
//                               sx={{ color: '#102dff' }}
//                               onClick={(e) => e.stopPropagation()}
//                             />
//                           }
//                           label="Question 5"
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                         {includeQuestion5 && (
//                           <Chip 
//                             label="Included" 
//                             size="small" 
//                             sx={{ 
//                               backgroundColor: '#102dff', 
//                               color: 'white',
//                               height: 20,
//                               fontSize: '10px',
//                             }} 
//                           />
//                         )}
//                       </Box>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                           <TextField
//                             fullWidth
//                             label="Question 5 Text"
//                             variant="outlined"
//                             size="small"
//                             value={question5_text}
//                             onChange={(e) => setQuestion5_text(e.target.value)}
//                             disabled={!includeQuestion5}
//                             placeholder="e.g., How did you hear about us?"
//                             required={includeQuestion5}
//                             error={includeQuestion5 && !question5_text}
//                             helperText={includeQuestion5 && !question5_text ? "Question text is required" : ""}
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <Typography variant="caption" color="text.secondary">
//                             ⓘ Answer will be provided by the customer in the form
//                           </Typography>
//                         </Grid>
//                       </Grid>
//                     </AccordionDetails>
//                   </Accordion>
//                 </Grid>
//               </Grid>

//               {/* Generate URL Button */}
//               <Box sx={{ mt: 4 }}>
//                 <Button
//                   variant="contained"
//                   onClick={generateUrl}
//                   fullWidth
//                   size="large"
//                   sx={{
//                     backgroundColor: '#102dff',
//                     color: 'white',
//                     py: 1.5,
//                     fontSize: '1rem',
//                     fontWeight: '600',
//                     borderRadius: 2,
//                     '&:hover': {
//                       backgroundColor: '#0a25d9',
//                     },
//                   }}
//                   startIcon={<AddIcon />}
//                 >
//                   Generate Integration URL
//                 </Button>
//               </Box>

//               {/* Generated URL */}
//               {!generate && urlcreated && (
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     mt: 3,
//                     p: 2,
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#f5f5f5',
//                     borderRadius: 2,
//                     border: `2px solid ${copied ? '#4caf50' : '#102dff'}`,
//                     position: 'relative',
//                     transition: 'border-color 0.3s',
//                   }}
//                 >
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       wordBreak: 'break-word',
//                       color: mode === 'dark' ? '#90caf9' : '#102dff',
//                       fontFamily: 'monospace',
//                       fontSize: '14px',
//                       pr: 5,
//                     }}
//                   >
//                     {urlcreated}
//                   </Typography>

//                   <Tooltip title={copied ? 'Copied!' : 'Copy URL'}>
//                     <IconButton
//                       onClick={() => {
//                         navigator.clipboard.writeText(urlcreated);
//                         handleCopy();
//                       }}
//                       sx={{
//                         position: 'absolute',
//                         top: 8,
//                         right: 8,
//                         backgroundColor: copied ? '#4caf50' : '#102dff',
//                         color: 'white',
//                         '&:hover': {
//                           backgroundColor: copied ? '#45a049' : '#0a25d9',
//                         },
//                       }}
//                     >
//                       {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
//                     </IconButton>
//                   </Tooltip>
//                 </Paper>
//               )}
//             </Paper>

//             {/* Integration Keys Reference */}
//             <Box sx={{ mt: 4 }}>
//               <LeedintegrationKeys />
//             </Box>
//           </Col>
//         </Row>
//       </Container>
//     </Box>
//   );
// };




















import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
  Autocomplete, TextField, Checkbox, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Snackbar, Alert, Tooltip, IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { createPortal } from 'react-dom';

import zapier     from '../../images/zapier.jpeg';
import make       from '../../images/make.jpg';
import integrately from '../../images/integrately.webp';

import { GetAll_stage_Data }        from '../../Redux/Actions/Stage_Action';
import { GetAllchannalData }         from '../../Redux/Actions/ChannalActions';
import { GetCommunicationwayData }   from '../../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData }         from '../../Redux/Actions/Campaign_Actions';
import { GetallProjectsdata }        from '../../Redux/Actions/Projects_Action';
import { Get_All_Sales_Action }      from '../../Redux/Actions/SalesAction';
import { Notify }                    from '../../Utility/Notify';
import { LeedintegrationKeys }       from './LeedintegrationKeys';
import { db_url }                    from '../../Api/BaseUrl';
import { useSidebarWidth }           from '../../Utility/useSidebarWidth';

/* ─── Integration platforms ─────────────────────────────────────────────── */
const allIntegration = [
  { id: 1, name: 'Zapier',      description: 'Connect with thousands of apps',  link: 'https://zapier.com',           img: zapier,      color: '#FF4F00' },
  { id: 2, name: 'Make',        description: 'Visual automation platform',       link: 'https://www.make.com/en',      img: make,        color: '#6E48AA' },
  { id: 3, name: 'Integrately', description: '1-click integrations',             link: 'https://app.integrately.com/', img: integrately, color: '#00A67E' },
];

/* ─── Icons ──────────────────────────────────────────────────────────────── */
const IconPlus     = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const IconKey      = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>;
const IconClose    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IconOpenLink = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>;
const IconCopy     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>;
const IconCheck2   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>;

/* ─── Keys Dialog (Portal) ───────────────────────────────────────────────── */
const KeysDialog = ({ isDark, onClose }) =>
  createPortal(
    <div onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} style={{
      position: 'fixed', inset: 0, zIndex: 999999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(10px)',
      padding: '20px', animation: 'mi-fadein 0.2s ease both',
    }}>
      <style>{`@keyframes mi-fadein{from{opacity:0}to{opacity:1}} @keyframes mi-slidein{from{opacity:0;transform:translateY(20px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}`}</style>
      <div style={{
        width: '100%', maxWidth: '780px', maxHeight: '85vh',
        background: isDark ? '#1e2132' : '#ffffff',
        borderRadius: '20px', overflow: 'hidden',
        border: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
        boxShadow: isDark ? '0 32px 80px rgba(0,0,0,0.55)' : '0 20px 60px rgba(0,0,0,0.15)',
        display: 'flex', flexDirection: 'column',
        animation: 'mi-slidein 0.26s cubic-bezier(0.34,1.15,0.64,1) both',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        {/* header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '20px 28px',
          borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
          background: isDark ? '#161828' : '#f8fafc',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '10px',
              background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
            }}><IconKey /></div>
            <div>
              <p style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0f172a' }}>Integration Keys</p>
              <p style={{ margin: 0, fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>Reference for API field names</p>
            </div>
          </div>
          <button onClick={onClose} style={{
            width: '34px', height: '34px', borderRadius: '10px',
            border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
            background: isDark ? '#252d45' : '#f8fafc',
            color: isDark ? '#9ca3af' : '#64748b',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
          }}><IconClose /></button>
        </div>
        {/* content */}
        <div style={{ overflowY: 'auto', padding: '24px 28px' }}>
          <LeedintegrationKeys />
        </div>
      </div>
    </div>,
    document.body
  );

/* ─── Question Accordion ─────────────────────────────────────────────────── */
const QuestionRow = ({ isDark, num, included, onToggle, text, onTextChange }) => (
  <Accordion sx={{
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    boxShadow: 'none', mb: 1,
    border: `1.5px solid ${included ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    borderRadius: '10px !important',
    '&:before': { display: 'none' },
    transition: 'border-color 0.2s',
  }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: isDark ? '#6b7280' : '#94a3b8' }} />}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
        <FormControlLabel
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              checked={included}
              onChange={(e) => { e.stopPropagation(); onToggle(e.target.checked); }}
              size="small"
              sx={{ color: '#2563eb', '&.Mui-checked': { color: '#2563eb' }, p: '4px' }}
            />
          }
          label={
            <span style={{ fontSize: '13px', fontWeight: 600, color: isDark ? '#e2e8f0' : '#374151', fontFamily: "'DM Sans', sans-serif" }}>
              Question {num}
            </span>
          }
        />
        {included && (
          <span style={{
            fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '20px',
            background: 'rgba(37,99,235,0.12)', color: '#2563eb', letterSpacing: '0.05em',
          }}>INCLUDED</span>
        )}
      </div>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0, pb: 2 }}>
      <TextField
        fullWidth size="small"
        label={`Question ${num} Text`}
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        disabled={!included}
        placeholder="e.g., What is your budget?"
        required={included}
        error={included && !text}
        helperText={included && !text ? 'Question text is required' : 'ⓘ Answer will be provided by the customer in the form'}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: isDark ? '#0f1117' : '#ffffff',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '14px',
            '& fieldset': { borderColor: isDark ? '#2d3248' : '#e2e8f0' },
            '&:hover fieldset': { borderColor: '#2563eb' },
            '&.Mui-focused fieldset': { borderColor: '#2563eb' },
          },
          '& .MuiInputLabel-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#2563eb' },
          '& .MuiFormHelperText-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '11px' },
          '& .MuiInputBase-input': { color: isDark ? '#f1f5f9' : '#0f172a' },
          '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: isDark ? '#4b5563' : '#94a3b8' },
        }}
      />
    </AccordionDetails>
  </Accordion>
);

/* ─── Autocomplete shared sx ─────────────────────────────────────────────── */
const acSx = (isDark) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    '& fieldset': { borderColor: isDark ? '#2d3248' : '#e2e8f0', borderWidth: '1.5px' },
    '&:hover fieldset': { borderColor: '#2563eb' },
    '&.Mui-focused fieldset': { borderColor: '#2563eb', boxShadow: '0 0 0 3px rgba(37,99,235,0.12)' },
  },
  '& .MuiInputLabel-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#2563eb' },
  '& .MuiInputBase-input': { color: isDark ? '#f1f5f9' : '#0f172a' },
  '& .MuiSvgIcon-root': { color: isDark ? '#6b7280' : '#94a3b8' },
});

/* ─── Component ──────────────────────────────────────────────────────────── */
export const MoreIntegration = () => {
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const dispatch     = useDispatch();
  const sidebarWidth = useSidebarWidth();

  const [userlogin, setUserlogin] = useState(null);
  const [keysOpen,  setKeysOpen]  = useState(false);
  const [copied,    setCopied]    = useState(false);
  const [copyOpen,  setCopyOpen]  = useState(false);
  const [urlcreated, setUrlcreated] = useState('');
  const [generated,  setGenerated]  = useState(false);

  /* fields */
  const [selectedProject,        setSelectedProject]        = useState(null);
  const [selectedSales,          setSelectedSales]          = useState(null);
  const [selectedStage,          setSelectedStage]          = useState(null);
  const [selectedChannal,        setSelectedChannal]        = useState(null);
  const [selectedCommunication,  setSelectedCommunication]  = useState(null);
  const [selectedCampaign,       setSelectedCampaign]       = useState(null);
  const [project,       setProject]       = useState('');
  const [salesdata,     setSalesdata]     = useState('');
  const [stage,         setStage]         = useState('');
  const [channal,       setChannal]       = useState('');
  const [commway,       setCommway]       = useState('');
  const [campaignid,    setCampaignid]    = useState('');
  const [redirectLink,  setRedirectLink]  = useState('');
  const [includeWhatsapp, setIncludeWhatsapp] = useState(false);
  const [includePhone2,   setIncludePhone2]   = useState(false);
  const [includeJobDesc,  setIncludeJobDesc]  = useState(false);

  /* questions */
  const [q, setQ] = useState([
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
    { included: false, text: '' },
  ]);
  const toggleQ   = (i, val) => setQ(prev => prev.map((x, idx) => idx === i ? { ...x, included: val } : x));
  const changeQTxt = (i, val) => setQ(prev => prev.map((x, idx) => idx === i ? { ...x, text: val } : x));

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  useEffect(() => {
    dispatch(GetAll_stage_Data());
    dispatch(GetAllchannalData());
    dispatch(GetCommunicationwayData());
    dispatch(GetAllCampainData());
    dispatch(GetallProjectsdata());
    dispatch(Get_All_Sales_Action());
  }, [dispatch]);

  const resStages   = useSelector((s) => s.Allstages.stage);
  const resChannal  = useSelector((s) => s.AllChannalRoot.channal);
  const resComm     = useSelector((s) => s.AllCommunicationway.communicationway);
  const resCampaign = useSelector((s) => s.AllCampaign.campaign);
  const resProjects = useSelector((s) => s.AllProjects.Projects);
  const resSales    = useSelector((s) => s.AllSales.sales);

  const stages    = Array.isArray(resStages?.data)   ? resStages.data   : [];
  const channels  = Array.isArray(resChannal?.data)  ? resChannal.data  : [];
  const commways  = Array.isArray(resComm?.data)     ? resComm.data     : [];
  const campaigns = Array.isArray(resCampaign?.data) ? resCampaign.data : [];
  const projects  = Array.isArray(resProjects?.data) ? resProjects.data : [];
  const salesData = (Array.isArray(resSales?.data) ? resSales.data : [])
    .filter(s => !['Default','Default M','Default T','Default S','Deveolper','Developer','Dev'].includes(s.name))
    .sort((a, b) => a.name === 'No Sales' ? -1 : b.name === 'No Sales' ? 1 : 0);

  let user = null;
  try { user = JSON.parse(localStorage.getItem('user')); } catch {}

  const dashboardRoute =
    userlogin?.data?.role === 'Admin'    ? '/dashboard'
  : userlogin?.data?.role === 'Marketer' ? '/dashboard'
  : '/';

  /* generate url */
  const generateUrl = () => {
    if (!project)     return Notify('error', 'Project is required', 'error');
    if (!salesdata)   return Notify('error', 'Sales is required', 'error');
    if (!channal)     return Notify('error', 'Channel is required', 'error');
    if (!commway)     return Notify('error', 'Communication way is required', 'error');
    if (!stage)       return Notify('error', 'Stage is required', 'error');
    if (!campaignid)  return Notify('error', 'Campaign is required', 'error');
    if (!user?.data?._id) return Notify('error', 'User is required', 'error');

    for (let i = 0; i < 5; i++) {
      if (q[i].included && !q[i].text)
        return Notify('error', `Question ${i + 1} text is required`, 'error');
    }

    const params = {
      addedby: user.data._id,
      stage, Channal: channal, project, salesdata,
      Communicationway: commway, campaignid,
      includePhone2: includePhone2 ? 'true' : 'false',
      includeWhatsapp: includeWhatsapp ? 'true' : 'false',
      includeJobDesc: includeJobDesc ? 'true' : 'false',
      ...q.reduce((acc, qi, i) => ({
        ...acc,
        [`includeQuestion${i+1}`]: qi.included ? 'true' : 'false',
        ...(qi.included && qi.text ? { [`question${i+1}_text`]: qi.text } : {}),
      }), {}),
      ...(redirectLink ? { campaignRedirectLink: redirectLink } : {}),
    };

    const queryParams = new URLSearchParams(params).toString();
    setUrlcreated(`${db_url}api/v1/users/create-with-params?${queryParams}`);
    setGenerated(true);
    setCopied(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(urlcreated);
    setCopied(true);
    setCopyOpen(true);
    setTimeout(() => setCopied(false), 2500);
  };

  /* section label style */
  const sectionLabel = (label, icon) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '8px',
      fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em',
      textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8',
      margin: '4px 0 14px', padding: '0 0 10px',
      borderBottom: `1px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
    }}>
      {icon}<span>{label}</span>
    </div>
  );

  const checkboxStyle = { color: '#2563eb', '&.Mui-checked': { color: '#2563eb' }, p: '4px' };
  const checkLabel = (label) => (
    <span style={{ fontSize: '13px', color: isDark ? '#e2e8f0' : '#374151', fontFamily: "'DM Sans', sans-serif" }}>
      {label}
    </span>
  );

  return (
    <>
      <div style={{
        position: 'fixed',
        top: '50px', left: sidebarWidth, right: 0, bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        overflowY: 'auto', overflowX: 'hidden',
        background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
        marginTop: '10px',
      }}>

        {/* ── Breadcrumb ── */}
        <div style={{
          padding: '14px 28px',
          backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
          display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', flexWrap: 'wrap',
        }}>
          <Link to={dashboardRoute} style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Dashboard</Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>Integration</span>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>More Integration</span>
        </div>

        <div style={{ padding: '24px 28px 48px' }}>

          {/* ── Header ── */}
          <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
                Integration Hub
              </h1>
              <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
                Connect your leads with popular automation platforms
              </p>
            </div>
            {/* Keys button */}
            <button
              onClick={() => setKeysOpen(true)}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                padding: '10px 18px', borderRadius: '10px', border: 'none',
                background: isDark ? '#252d45' : '#f1f5f9',
                color: isDark ? '#93c5fd' : '#2563eb',
                fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                border: `1.5px solid ${isDark ? '#2d3248' : '#dbeafe'}`,
                transition: 'all 0.2s', fontFamily: "'DM Sans', sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? '#1e3a8a22' : '#dbeafe'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = isDark ? '#252d45' : '#f1f5f9'; }}
            >
              <IconKey /> View Integration Keys
            </button>
          </div>

          {/* ── Integration Cards ── */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '16px', marginBottom: '28px' }}>
            {allIntegration.map((item) => (
              <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div style={{
                  borderRadius: '16px', overflow: 'hidden',
                  border: `1.5px solid ${isDark ? '#2a2f45' : '#e2e8f0'}`,
                  background: isDark ? '#1e2132' : '#ffffff',
                  transition: 'all 0.2s', cursor: 'pointer',
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = `0 12px 32px ${item.color}30`;
                    e.currentTarget.style.borderColor = item.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'none';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = isDark ? '#2a2f45' : '#e2e8f0';
                  }}
                >
                  <div style={{ position: 'relative', height: '120px', overflow: 'hidden' }}>
                    <img src={item.img} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <div style={{ position: 'absolute', inset: 0, background: `linear-gradient(135deg,${item.color}50,transparent)` }} />
                  </div>
                  <div style={{ padding: '14px 16px', textAlign: 'center' }}>
                    <p style={{ margin: '0 0 4px', fontSize: '15px', fontWeight: 700, color: isDark ? '#f1f5f9' : item.color }}>{item.name}</p>
                    <p style={{ margin: '0 0 10px', fontSize: '12px', color: isDark ? '#6b7280' : '#94a3b8' }}>{item.description}</p>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: '4px',
                      padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 600,
                      background: item.color, color: '#fff',
                    }}>
                      Connect <IconOpenLink />
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* ── Configuration Card ── */}
          <div style={{
            backgroundColor: isDark ? '#1e2132' : '#ffffff',
            borderRadius: '20px', padding: '32px 36px',
            boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
            border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
          }}>

            {/* card title */}
            <div style={{ marginBottom: '24px' }}>
              <h2 style={{ fontSize: '18px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px' }}>
                Integration Configuration
              </h2>
              <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
                Fill in the required fields to generate your integration URL
              </p>
            </div>

            {/* Required */}
            {sectionLabel('Required Fields', <svg width="12" height="12" viewBox="0 0 24 24" fill="#ef4444"><circle cx="12" cy="12" r="10"/></svg>)}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
              {[
                { label: 'Project *',           options: projects,  getLabel: o => o.name,           val: selectedProject,       onChange: (_, v) => { setSelectedProject(v);       setProject(v?._id || ''); } },
                { label: 'Sales *',             options: salesData, getLabel: o => o.name,           val: selectedSales,         onChange: (_, v) => { setSelectedSales(v);         setSalesdata(v?._id || ''); } },
                { label: 'Stage *',             options: stages,    getLabel: o => o.name,           val: selectedStage,         onChange: (_, v) => { setSelectedStage(v);         setStage(v?._id || ''); } },
                { label: 'Channel *',           options: channels,  getLabel: o => o.name,           val: selectedChannal,       onChange: (_, v) => { setSelectedChannal(v);       setChannal(v?._id || ''); } },
                { label: 'Communication Way *', options: commways,  getLabel: o => o.name,           val: selectedCommunication, onChange: (_, v) => { setSelectedCommunication(v); setCommway(v?._id || ''); } },
                { label: 'Campaign *',          options: campaigns, getLabel: o => o.CampainName,    val: selectedCampaign,      onChange: (_, v) => { setSelectedCampaign(v);      setCampaignid(v?._id || ''); } },
              ].map((f) => (
                <Autocomplete
                  key={f.label}
                  options={f.options}
                  getOptionLabel={(o) => f.getLabel(o) || ''}
                  value={f.val}
                  onChange={f.onChange}
                  renderInput={(params) => (
                    <TextField {...params} label={f.label} size="small" sx={acSx(isDark)} />
                  )}
                />
              ))}
            </div>

            {/* Optional */}
            {sectionLabel('Basic Optional Fields', null)}
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
              {[
                { label: 'WhatsApp Number', val: includeWhatsapp, set: setIncludeWhatsapp },
                { label: 'Secondary Phone', val: includePhone2,   set: setIncludePhone2 },
                { label: 'Job Description', val: includeJobDesc,  set: setIncludeJobDesc },
              ].map((c) => (
                <div key={c.label} style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  padding: '8px 14px', borderRadius: '10px',
                  border: `1.5px solid ${c.val ? '#2563eb' : (isDark ? '#2d3248' : '#e2e8f0')}`,
                  background: c.val ? 'rgba(37,99,235,0.08)' : (isDark ? '#151827' : '#f8fafc'),
                  cursor: 'pointer', transition: 'all 0.18s',
                }} onClick={() => c.set(!c.val)}>
                  <div style={{
                    width: '16px', height: '16px', borderRadius: '4px',
                    border: `2px solid ${c.val ? '#2563eb' : (isDark ? '#4b5563' : '#cbd5e1')}`,
                    background: c.val ? '#2563eb' : 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.18s', flexShrink: 0,
                  }}>
                    {c.val && <span style={{ color: '#fff', fontSize: '10px', fontWeight: 700 }}>✓</span>}
                  </div>
                  <span style={{ fontSize: '13px', fontWeight: 500, color: c.val ? '#2563eb' : (isDark ? '#9ca3af' : '#64748b'), fontFamily: "'DM Sans', sans-serif" }}>
                    {c.label}
                  </span>
                </div>
              ))}
            </div>

            {/* Redirect link */}
            <div style={{ marginBottom: '24px' }}>
              <TextField
                fullWidth size="small"
                label="Campaign Redirect Link (Optional)"
                value={redirectLink}
                onChange={(e) => setRedirectLink(e.target.value)}
                placeholder="https://example.com/thank-you"
                helperText="URL to redirect after lead creation"
                InputProps={{ startAdornment: <LinkIcon sx={{ mr: 1, fontSize: 18, color: isDark ? '#6b7280' : '#94a3b8' }} /> }}
                sx={acSx(isDark)}
              />
            </div>

            {/* Questions */}
            {sectionLabel('Custom Questions', <HelpOutlineIcon sx={{ fontSize: 14 }} />)}
            <div style={{ marginBottom: '24px' }}>
              {q.map((qi, i) => (
                <QuestionRow
                  key={i} isDark={isDark} num={i + 1}
                  included={qi.included} onToggle={(v) => toggleQ(i, v)}
                  text={qi.text} onTextChange={(v) => changeQTxt(i, v)}
                />
              ))}
            </div>

            {/* divider */}
            <div style={{ height: '1px', background: isDark ? '#2a2f45' : '#e2e8f0', margin: '8px 0 24px' }} />

            {/* Generate button */}
            <button
              onClick={generateUrl}
              style={{
                width: '100%', padding: '15px', borderRadius: '12px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '14px', fontWeight: 700,
                letterSpacing: '0.06em', textTransform: 'uppercase',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans', sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              <IconPlus /> Generate Integration URL
            </button>

            {/* Generated URL */}
            {generated && urlcreated && (
              <div style={{
                marginTop: '20px', padding: '16px 20px', borderRadius: '12px',
                background: isDark ? '#151827' : '#f0f7ff',
                border: `1.5px solid ${copied ? '#22c55e' : '#2563eb'}`,
                position: 'relative', transition: 'border-color 0.3s',
              }}>
                <p style={{ margin: '0 40px 0 0', fontSize: '12px', fontFamily: 'monospace', wordBreak: 'break-all', color: isDark ? '#93c5fd' : '#1d4ed8', lineHeight: 1.7 }}>
                  {urlcreated}
                </p>
                <button
                  onClick={handleCopy}
                  style={{
                    position: 'absolute', top: '12px', right: '12px',
                    width: '34px', height: '34px', borderRadius: '10px', border: 'none',
                    background: copied ? '#22c55e' : '#2563eb',
                    color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    cursor: 'pointer', transition: 'background 0.2s',
                  }}
                >
                  {copied ? <IconCheck2 /> : <IconCopy />}
                </button>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Keys Dialog */}
      {keysOpen && <KeysDialog isDark={isDark} onClose={() => setKeysOpen(false)} />}

      {/* Snackbar */}
      <Snackbar open={copyOpen} autoHideDuration={2000} onClose={() => setCopyOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <Alert severity="success" sx={{ width: '100%' }}>URL copied to clipboard!</Alert>
      </Snackbar>
    </>
  );
};